import React from 'react';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import AtlasV2MetricListContainer from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricListContainer';
import AtlasV2ProductListContainer from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ProductListContainer';
import ProductCell from 'src/components/BeaconV2Components/ProductCell/ProductCell';
import { ProductEntity } from 'sl-api-connector';

const fields: Field[] = [
  {
    name: 'retailSales',
    displayName: 'RETAIL SALES'
  },
  {
    name: 'retailPrice',
    displayName: 'RETAIL PRICE'
  },
  {
    name: 'unitsSold',
    displayName: 'UNITS SOLD'
  }
];

/**
 * Shows product grid for Retail Sales summary
 */
const AtlasV2SalesProductGrid = () => {
  const { isProductEntity } = useProductEntity();
  const weekEndingFields = fields.map(removeComparisonFormatter);

  return isProductEntity ? (
    <AtlasV2MetricListContainer
      entityTableHeaderProps={{
        title: 'Retail Sales by Week'
      }}
      indexName="sales"
      sortFieldName="retailSales"
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  ) : (
    <AtlasV2ProductListContainer
      indexName="sales"
      fields={fields}
      mainFieldName="retailSales"
      sortFieldName="retailSales"
      entityTableHeaderProps={{
        title: 'Retail Sales by Product'
      }}
      headColumnDefinition={{
        headerName: 'Products',
        valueFormatter: (_, row: { product: ProductEntity }) => (
          <div style={{ width: '547px' }}>
            <ProductCell
              key={row.product.stacklineSku}
              stacklineSku={row.product.stacklineSku}
              title={row.product.title}
            />
          </div>
        )
      }}
      appTableProps={{
        sx: {
          marginTop: '-64px',
          'tr td:first-child': {
            width: '600px',
            paddingRight: '40px'
          }
        }
      }}
    />
  );
};

export default AtlasV2SalesProductGrid;
